import React, {Component} from "react";
import '../../../../style/contacts.css'
import {AiOutlineClose, AiOutlinePlus, AiOutlineEdit} from "react-icons/ai";
import {MdOutlineDeleteOutline} from "react-icons/md";
import {Modal} from 'react-bootstrap';
import {Box, Button, CircularProgress, MenuItem, Select} from "@mui/material";
import {green} from "@mui/material/colors";
import Skeleton from "react-loading-skeleton";
import FormControl from "@mui/material/FormControl";
import axios from "axios";
import api, { API_BASE_URL } from '../../../../api/client';
import ListPagination, {paginateItems} from '../../../CustomInputs/ListPagination';

class contacts extends Component {
    state = {
        searchLoading: true,
        loading: false,
        syncLoading: false,
        contacts: [],
        show: false,
        inputTelephone: [],
        inputMobile: [],
        name: [],
        telephoneNumbers: [],
        mobileNumbers: [],
        searchType: "name",
        listPage: 1,
        pageSize: 20,
        editingContactId: null,
        deleteContactId: null,
    }

    reloadContacts = async () => {
        this.setState({searchLoading: true});
        try {
            const data = await api.get('/api/v1/supervisor/phoneBook').then(r => r.data);
            this.setState({contacts: Array.isArray(data) ? data : [], searchLoading: false});
        } catch (e) {
            this.setState({searchLoading: false});
        }
    }

    syncFromPersons = async () => {
        if (this.state.syncLoading) return;
        this.setState({syncLoading: true});
        try {
            const result = await api.post('/api/v1/supervisor/phoneBook/sync-from-persons').then(r => r.data);
            await this.reloadContacts();
            window.alert(
                `همگام‌سازی انجام شد.\nجدید: ${result?.created ?? 0}\nبه‌روز: ${result?.updated ?? 0}\nرد شده (تکراری/بدون شماره): ${result?.skipped ?? 0}\nاشخاص بررسی‌شده: ${result?.scannedPersons ?? 0}`
            );
        } catch (e) {
            window.alert('همگام‌سازی از اشخاص ناموفق بود');
        } finally {
            this.setState({syncLoading: false});
        }
    }

    async componentDidMount() {
        axios.get(`${API_BASE_URL}/api/v1/supervisor/phoneBook`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
            .then((data) => this.setState({
                contacts: data,
                searchLoading: false
            })).catch(() => {
            if (localStorage.getItem('role') === 'MANAGER') {
                axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                    .then((response) => {
                        if (response.headers["accesstoken"]) {
                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                            axios.get(`${API_BASE_URL}/api/v1/supervisor/phoneBook`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                .then((data) => this.setState({
                                    contacts: data,
                                    searchLoading: false
                                }))
                        } else {
                            window.location = '/'
                        }
                    })
            } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                    .then((response) => {
                        if (response.headers["accesstoken"]) {
                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                            axios.get(`${API_BASE_URL}/api/v1/supervisor/phoneBook`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                .then((data) => this.setState({
                                    contacts: data,
                                    searchLoading: false
                                }))
                        } else {
                            window.location = '/'
                        }
                    })
            }
        })
    }

    render() {
        return (
            <>
                <div className="page-title-row">
                    <h4>دفترچه تلفن</h4>
                    <div className="page-actions">
                        <button
                            className="btn btn-outline-secondary my-0 ms-2"
                            type="button"
                            disabled={this.state.syncLoading}
                            onClick={this.syncFromPersons}
                            title="شماره‌های ثبت‌شده برای اقامتگران را به دفترچه اضافه می‌کند"
                        >
                            {this.state.syncLoading ? 'در حال همگام‌سازی...' : 'وارد کردن از اشخاص'}
                        </button>
                        <button className="btn-done my-0" onClick={() => {
                            this.handleShow()
                        }}><AiOutlinePlus className='ms-2'/>افزودن مخاطب
                        </button>
                    </div>
                </div>
                <div className="search-box search-toolbar">
                    <div className="search-field">
                        <span className="search-field-label">براساس</span>
                        <FormControl fullWidth size="small">
                            <Select
                                className="search-select"
                                id="select-field"
                                value={this.state.searchType}
                                onChange={(value) => this.setState({searchType: value.target.value})}>
                                <MenuItem value={"name"}>نام و نام خانوادگی</MenuItem>
                                <MenuItem value={"mobileNumbers"}>شماره همراه</MenuItem>
                                <MenuItem value={"telephoneNumbers"}>تلفن ثابت</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                    <div className="search-field search-field-grow">
                        <span className="search-field-label">جستجو</span>
                        <div className="search-input-wrap">
                            <i className="bi bi-search" aria-hidden="true"/>
                            <input type="text"
                                   id="inputSearch"
                                   placeholder="جسـتجـو..."
                                   onChange={this.handleSearchInput}/>
                        </div>
                    </div>
                </div>
                <div className="table-box">
                    <table className='table'>
                        <thead>
                        <tr>
                            <th>نام و نام خانوادگی</th>
                            <th>تلفن همراه</th>
                            <th>تلفن ثابت</th>
                            <th>عملیات</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            this.state.searchLoading ?
                                [...Array(5)].map((x, i) =>
                                    <tr key={i}>
                                        <td><Skeleton animation="wave" height={23} width="100%"/></td>
                                        <td><Skeleton animation="wave" height={23} width="100%"/></td>
                                        <td><Skeleton animation="wave" height={23} width="100%"/></td>
                                    </tr>
                                )
                                :
                                (() => {
                                    const {pageItems} = paginateItems(
                                        this.state.contacts || [], this.state.listPage, this.state.pageSize
                                    );
                                    if (pageItems.length === 0) {
                                        return (
                                            <tr className="table-empty-row">
                                                <td colSpan={4}>موردی یافت نشد</td>
                                            </tr>
                                        );
                                    }
                                    return pageItems.map((i) => (
                                    <tr key={i.id || i.name}>
                                        <td>{i.name}</td>
                                        <td>{(i.mobileNumbers || []).map((num) => (<div className="mb-2" key={num}>{num}</div>))}</td>
                                        <td>{(i.telephoneNumbers || []).map((num) => (
                                            <div className="mb-2" key={num}>{num}</div>))}</td>
                                        <td>
                                            <div className="table-actions">
                                                <button type="button" className="icon-btn icon-btn-warning" title="ویرایش"
                                                        onClick={() => this.openEditContact(i)}>
                                                    <AiOutlineEdit size={16}/>
                                                </button>
                                                <button type="button" className="icon-btn icon-btn-danger" title="حذف"
                                                        onClick={() => this.setState({deleteContactId: i.id})}>
                                                    <MdOutlineDeleteOutline size={16}/>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    ));
                                })()
                        }
                        </tbody>
                    </table>
                </div>
                {(() => {
                    if (this.state.searchLoading) return null;
                    const {totalPages, page, total} = paginateItems(
                        this.state.contacts || [], this.state.listPage, this.state.pageSize
                    );
                    return (
                        <>
                            <div className="text-muted small text-center mt-2">از {total} مورد</div>
                            <ListPagination page={page} totalPages={totalPages}
                                            onNewPage={(p) => this.setState({listPage: p})}/>
                        </>
                    );
                })()}

                <Modal className='report-modal' centered show={this.state.show} onHide={this.handleClose}>
                    <Modal.Header>
                        <Modal.Title><span>{this.state.editingContactId ? 'ویرایش مخاطب' : 'ثبت مخاطب'}</span></Modal.Title>
                        <button className='btn' onClick={() => {
                            this.handleClose()
                        }}><AiOutlineClose/></button>
                    </Modal.Header>
                    <Modal.Body>
                        <div className='input-group-register mb-3'>
                            <input type='text' className='input form-control' onChange={(e) => {
                                this.getValueInputName(e.target.value)
                            }}/>
                            <label className="placeholder" style={{right: '12px'}}>نام و نام خانوادگی</label>
                        </div>

                        <div className='input-group-register mb-3'>
                            <input type='text' className='input form-control' onChange={(e) => {
                                this.getValueInputTelephone(e.target.value, 0)
                            }}/>
                            <label className="placeholder" style={{right: '12px'}}>تلفن ثابت</label>
                        </div>

                        {
                            this.state.inputTelephone.map((telephone, index) => (
                                <div className='input-group-register mb-3'>
                                    <AiOutlineClose className='btn-delete-input' onClick={() => {
                                        this.deleteInputTelephone(index)
                                    }}/>
                                    <input type='text' className='input form-control' onChange={(e) => {
                                        this.getValueInputTelephone(e.target.value, index + 1)
                                    }}/>
                                    <label className="placeholder" style={{right: '12px'}}>تلفن ثابت</label>
                                </div>
                            ))
                        }
                        <div className="add-input-contact mb-3" onClick={() => {
                            this.addInputTelephoneNumbers()
                        }}>
                            <AiOutlinePlus className='ms-2'/>
                        </div>
                        <div className='input-group-register mb-3'>
                            <input type='text' className='input form-control' onChange={(e) => {
                                this.getValueInputMobile(e.target.value, 0)
                            }}/>
                            <label className="placeholder" style={{right: '12px'}}>تلفن همراه</label>
                        </div>
                        {
                            this.state.inputMobile.map((mobile, index) => (
                                <div className='input-group-register mb-3'>
                                    <AiOutlineClose className='btn-delete-input' onClick={() => {
                                        this.deleteInputMobile(index)
                                    }}/>
                                    <input type='text' className='input form-control' onChange={(e) => {
                                        this.getValueInputMobile(e.target.value, index + 1)
                                    }}/>
                                    <label className="placeholder" style={{right: '12px'}}>تلفن همراه</label>
                                </div>
                            ))
                        }
                        <div className="add-input-contact mb-3" onClick={() => {
                            this.addInputMobileNumbers()
                        }}>
                            <AiOutlinePlus className='ms-2'/>
                        </div>

                        <Box sx={{m: 1, position: 'relative'}}>
                            <Button
                                className={"buttonDone w-100"}
                                variant="contained"
                                disabled={this.state.loading}
                                onClick={() => {
                                    this.handleRecordContact();
                                }}
                            >
                                ثبت
                            </Button>
                            {this.state.loading && (
                                <CircularProgress
                                    size={24}
                                    sx={{
                                        color: green[500],
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        marginTop: '-12px',
                                        marginLeft: '-12px',
                                    }}
                                />
                            )}
                        </Box>
                    </Modal.Body>
                </Modal>
                <Modal centered show={!!this.state.deleteContactId} onHide={() => this.setState({deleteContactId: null})}>
                    <Modal.Header closeButton><Modal.Title>حذف مخاطب</Modal.Title></Modal.Header>
                    <Modal.Body>آیا از حذف این مخاطب مطمئن هستید؟</Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-light" onClick={() => this.setState({deleteContactId: null})}>انصراف</button>
                        <button className="btn btn-danger" onClick={() => this.handleDeleteContact(this.state.deleteContactId)}>حذف</button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }

    openEditContact = (contact) => {
        this.setState({
            show: true,
            editingContactId: contact.id,
            name: contact.name || '',
            telephoneNumbers: contact.telephoneNumbers || [],
            mobileNumbers: contact.mobileNumbers || [],
            inputTelephone: (contact.telephoneNumbers || []).slice(1),
            inputMobile: (contact.mobileNumbers || []).slice(1),
        });
    }

    handleDeleteContact = async (id) => {
        if (!id) return;
        this.setState({loading: true});
        try {
            await axios.delete(`${API_BASE_URL}/api/v1/supervisor/phoneBook/${id}`, {
                headers: {'Authorization': localStorage.getItem('accessToken')}
            });
            this.setState({deleteContactId: null});
            await this.reloadContacts();
        } finally {
            this.setState({loading: false});
        }
    }

    reloadContacts = async () => {
        const data = await axios.get(`${API_BASE_URL}/api/v1/supervisor/phoneBook`, {
            headers: {'Authorization': localStorage.getItem('accessToken')}
        }).then(r => r.data);
        this.setState({contacts: data, searchLoading: false});
    }

    handleSearchInput = async (e) => {
        this.setState({searchLoading: true, listPage: 1})
        axios.get(`${API_BASE_URL}/api/v1/supervisor/phoneBook/search?${this.state.searchType}=${e.target.value}`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
            .then((data) => this.setState({
                contacts: data,
                searchLoading: false
            })).catch(() => {
            if (localStorage.getItem('role') === 'MANAGER') {
                axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                    .then((response) => {
                        if (response.headers["accesstoken"]) {
                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                            axios.get(`${API_BASE_URL}/api/v1/supervisor/phoneBook/search?${this.state.searchType}=${e.target.value}`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                .then((data) => this.setState({
                                    contacts: data,
                                    searchLoading: false
                                }))
                        } else {
                            window.location = '/'
                        }
                    })
            } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                    .then((response) => {
                        if (response.headers["accesstoken"]) {
                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                            axios.get(`${API_BASE_URL}/api/v1/supervisor/phoneBook/search?${this.state.searchType}=${e.target.value}`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                .then((data) => this.setState({
                                    contacts: data,
                                    searchLoading: false
                                }))
                        } else {
                            window.location = '/'
                        }
                    })
            }
        })
    }

    handleClose = () => {
        this.setState({
            show: false,
            editingContactId: null,
            name: '',
            telephoneNumbers: [],
            mobileNumbers: [],
            inputTelephone: [],
            inputMobile: [],
        })
    };

    handleShow = () => {
        this.setState({
            show: true,
            editingContactId: null,
            name: '',
            telephoneNumbers: [],
            mobileNumbers: [],
            inputTelephone: [],
            inputMobile: [],
        })
    }

    addInputTelephoneNumbers = () => {
        const newInputTelephone = this.state.inputTelephone.concat(
            ""
        )
        this.setState({inputTelephone: newInputTelephone});
    }

    addInputMobileNumbers = () => {
        const newInputMobile = this.state.inputMobile.concat(
            ""
        )
        this.setState({inputMobile: newInputMobile});
    }

    getValueInputName = (e) => {
        this.setState({name: e})
    }
    getValueInputTelephone = (e, index) => {
        const updateTelephone = [...this.state.telephoneNumbers];
        updateTelephone[index] = e;
        this.setState({telephoneNumbers: updateTelephone});
    }

    getValueInputMobile = (e, index) => {
        const updateMobile = [...this.state.mobileNumbers];
        updateMobile[index] = e;
        this.setState({mobileNumbers: updateMobile});
    }

    deleteInputTelephone = (i) => {
        const updateInputsTelephone = [...this.state.inputTelephone];
        updateInputsTelephone.splice(i, 1)
        this.setState({inputTelephone: updateInputsTelephone});
    }

    deleteInputMobile = (i) => {
        const updateInputsMobile = [...this.state.inputMobile];
        updateInputsMobile.splice(i, 1);
        this.setState({inputMobile: updateInputsMobile});
    }

    handleRecordContact = async () => {
        const newContact = {
            name: this.state.name,
            telephoneNumbers: this.state.telephoneNumbers,
            mobileNumbers: this.state.mobileNumbers
        }
        this.setState({loading: true})
        const saveRequest = this.state.editingContactId
            ? axios.put(`${API_BASE_URL}/api/v1/supervisor/phoneBook/${this.state.editingContactId}`, newContact, {headers: {'Authorization': localStorage.getItem('accessToken')}})
            : axios.post(`${API_BASE_URL}/api/v1/supervisor/phoneBook`, newContact, {headers: {'Authorization': localStorage.getItem('accessToken')}});
        await saveRequest.then(response => response.data)
            .then(() => this.setState({
                loading: false
            })).catch(() => {
                if (localStorage.getItem('role') === 'MANAGER') {
                    axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                        .then((response) => {
                            if (response.headers["accesstoken"]) {
                                localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                (this.state.editingContactId
                                    ? axios.put(`${API_BASE_URL}/api/v1/supervisor/phoneBook/${this.state.editingContactId}`, newContact, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                                    : axios.post(`${API_BASE_URL}/api/v1/supervisor/phoneBook`, newContact, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                                ).then(response => response.data)
                                    .then(() => this.setState({
                                        loading: false
                                    }))
                            } else {
                                window.location = '/'
                            }
                        })
                } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                    axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                        .then((response) => {
                            if (response.headers["accesstoken"]) {
                                localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                (this.state.editingContactId
                                    ? axios.put(`${API_BASE_URL}/api/v1/supervisor/phoneBook/${this.state.editingContactId}`, newContact, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                                    : axios.post(`${API_BASE_URL}/api/v1/supervisor/phoneBook`, newContact, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                                ).then(response => response.data)
                                    .then(() => this.setState({
                                        loading: false
                                    }))
                            } else {
                                window.location = '/'
                            }
                        })
                }
            })

        this.handleClose();
        await this.reloadContacts();
    }


}

export default contacts;